var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalanceBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 436,
    viewBox: "0 0 568 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 568,
    height: 436,
    rx: 8,
    fill: "#5356FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M-2.34293e-05 0.000290263L-2.36998e-06 373.766C34.8829 399.565 69.9041 417.424 105.302 415.717C249.583 408.752 290.189 107.406 438.452 53.7809C479.95 38.7715 522.248 57.1748 565 87.2609L565 0.000213623L-2.34293e-05 0.000290263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M3.05176e-05 436L393.417 436C396.14 415.924 396.846 395.977 394.881 376.207C377.132 197.532 170.752 155.022 89.7893 4.1536e-05L5.95177e-06 5.37155e-05L3.05176e-05 436Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceBg);
export default __webpack_public_path__ + "static/media/balance-bg.075324268d77f079c52c9dafdbbb43b2.svg";
export { ForwardRef as ReactComponent };